import { render, staticRenderFns } from "./DeactSysFunction.vue?vue&type=template&id=e323522a"
import script from "./DeactSysFunction.vue?vue&type=script&lang=js"
export * from "./DeactSysFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports